<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/W9MP07/media/FC-9781398492578.jpg?1695340671728" alt="This image is the cover for the book Baz"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Baz
      </h1>
      <p class="bookDescription body article font2">
        <p>This book begins when “Baz” starts his life, growing up with his siblings, growing up through his school, working, and then married life. This shows his life with the highs and lows until just after his retirement. It is hoped that younger readers will see that they can achieve many things in life, and that many readers will be able to relate their own experiences to the stories narrated in this book.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barry R. Hale
      </h2>
      
      <p class="authorDescription body article">This book is about the author, who grew up in Cheshire, in a family of ten, his early years were quite shy; this left him as he got older especially when leaving school and starting work. After he married and joined the Territorial Army gained confidence and later in life ran a successful butcher’s business. Only once retired began to put his past life down, when family and friends read his first manuscript, then decided to write Baz with the backing of his wife, who has supported him through his married life.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24e80098